import { ITooltipParams } from 'ag-grid-enterprise';

export const approximateTooltip = (
  params: ITooltipParams,
  keyFieldName: string,
): string => {
  if (params?.data[keyFieldName]?.isMasked && params?.value !== 0) {
    return 'This number is an approximation to protect your seller information';
  }

  return '';
};

export const approximateTooltipForTotal = (
  isMasked: boolean,
  totalValue: number,
): string => {
  if (isMasked && totalValue !== 0) {
    return 'This total contains an approximated number';
  }

  return '';
};

export const enum ApproximateSymbol {
  SINGLE_TILDE = '~',
  DOUBLE_TILDE = '≈',
  DOUBLE_ASTERISK = '**',
  EMPTY = '',
}
